import { render, staticRenderFns } from "./SupplierProgressReportWidget.vue?vue&type=template&id=21c68f6c&"
import script from "./SupplierProgressReportWidget.vue?vue&type=script&lang=js&"
export * from "./SupplierProgressReportWidget.vue?vue&type=script&lang=js&"
import style0 from "./SupplierProgressReportWidget.vue?vue&type=style&index=0&id=21c68f6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports